import { render, staticRenderFns } from "./GroupSubgroupSelector.vue?vue&type=template&id=39a9ebd3&scoped=true&"
import script from "./GroupSubgroupSelector.vue?vue&type=script&lang=js&"
export * from "./GroupSubgroupSelector.vue?vue&type=script&lang=js&"
import style0 from "./GroupSubgroupSelector.vue?vue&type=style&index=0&id=39a9ebd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a9ebd3",
  null
  
)

export default component.exports